<template>
  <b-form @submit="onSubmit" @reset="onReset">
    <div v-if="busyFetching" class="text-center">
      <i class="fa fa-4x fa-spinner fa-pulse"></i>
    </div>
    <div v-else v-for="coll in questionCollection" :key="coll.languageId">
      <div v-for="(question, questionIndex) in coll.questions" :key="questionIndex">
        <b-card no-body class="mb-1">

          <b-card-header header-tag="header" class="p-1" role="tab">
            <b-button style="text-align: left; padding-left: 20px;" block href="#" v-b-toggle="'accordion' + questionIndex" variant="info">
              {{$t('question')}}: {{questionIndex+1}}
            </b-button>
          </b-card-header>
          <b-collapse class="collapse" :id="'accordion' + questionIndex" accordion="question-accordion" role="tabpanel">
            <gnum-module :question="question"
                          :questionIndex="questionIndex"
                          :isPartOfCollection="true"
                          v-on:onDeleteQuestion="onDeleteQuestion">
            </gnum-module>
          </b-collapse>
        </b-card>
      </div>
      <b-button ref="addQuestionButton"
                variant="outline-primary"
                style="margin:5px 0px 10px 0px; width: 100%; font-weight: bold;"
                @click.stop="$emit('addQuestion', coll.questions)">
                +
      </b-button>
      <b-form-group>
        <b-button type="submit" class="me-2">{{ $t('save') }}</b-button>
        <b-button type="reset" variant="danger">{{ $t('cancel') }}</b-button>
      </b-form-group>
    </div>
  </b-form>
</template>

<style scoped>
.collapse {
  padding: 15px;
}
</style>

<script>
import GnumModule from './modules/gnummodule'

export default {
  name: 'question-editor-gnum',
  components: {
    GnumModule
  },

  methods: {
    onSubmit: function(evt) {
      evt.preventDefault()
      var data = this.questionCollection[0]
      this.$emit('formSubmitted', data)
    },
    onDeleteQuestion(index) {
      this.$emit('deleteQuestion', index)
    },
    onReset: function(evt) {
      evt.preventDefault()
      this.$router.go(-1)
    }
  },
  props: {
    questionCollection: [],
    busyFetching: false
  }
}
</script>
